import { ArrowDownRight, ArrowUpRight, Circle } from "lucide-react";

const fmtCompact = (v) => {
  const abs = Math.abs(v || 0);
  if (abs >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  return `₹${Math.round(v || 0).toLocaleString("en-IN")}`;
};

// Visual signal for the txn bucket — green inflow, orange outflow, gray neutral.
const bucketStyle = (bucket) => {
  const b = (bucket || "").toLowerCase();
  if (["sold units", "transfer out", "idcw payout", "dividend payout"].some((k) => b.includes(k))) {
    return { color: "text-orange-700", bg: "bg-orange-50", icon: ArrowUpRight };
  }
  if (b.includes("active") || b.includes("purchase")) {
    return { color: "text-green-700", bg: "bg-green-50", icon: ArrowDownRight };
  }
  return { color: "text-gray-600", bg: "bg-gray-50", icon: Circle };
};

const MobileTransactionCard = ({ txn }) => {
  const amount = parseFloat(txn.amount) || 0;
  const units = parseFloat(txn.units) || 0;
  const bucket = txn.reflecting_in || "Unknown";
  const { color, bg, icon: Icon } = bucketStyle(bucket);
  const source = (txn.source || "").toUpperCase().includes("WBR") ? "CAMS" : "Karvy";
  const date = txn.trade_date || txn.transaction_date || "—";

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex gap-2 min-w-0 flex-1">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${bg} ${color}`}>
            <Icon className="w-4 h-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-gray-900 leading-tight line-clamp-2">
              {txn.scheme_name || "—"}
            </p>
            <p className="text-[11px] text-gray-500 mt-0.5 truncate">
              {txn.description || txn.transaction_desc || "—"}
            </p>
          </div>
        </div>
        <div className="text-right flex-shrink-0">
          <p className={`text-sm font-bold ${color}`}>{fmtCompact(amount)}</p>
          <p className="text-[11px] text-gray-500 mt-0.5">{date}</p>
        </div>
      </div>
      <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-gray-100 flex-wrap">
        <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${bg} ${color}`}>
          {bucket}
        </span>
        <span className="text-[10px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 font-mono">
          {txn.folio_no || "—"}
        </span>
        <span className="text-[10px] px-1.5 py-0.5 rounded bg-blue-50 text-blue-700">
          {source}
        </span>
        {units !== 0 && (
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
            {units.toFixed(3)} units
          </span>
        )}
      </div>
    </div>
  );
};

const MobileTransactionsCards = ({ rows = [], emptyMessage = "No transactions" }) => {
  if (!rows.length) {
    return <div className="text-center py-12 text-sm text-gray-500">{emptyMessage}</div>;
  }
  return (
    <div className="space-y-2.5 px-1 pb-3" data-testid="mobile-transactions-cards">
      {rows.map((t, i) => (
        <MobileTransactionCard key={`${t.folio_no}-${t.txn_no || t.trade_date}-${i}`} txn={t} />
      ))}
    </div>
  );
};

export default MobileTransactionsCards;
